import makeApiCall from "./axiosIndex";

const departments = {
    fetchDeptData: (): Promise<any> => makeApiCall<any>({ method: 'get', url: '/seller/fetchDept' }),
    deleteDeptById: (deptID: any): Promise<any> => makeApiCall<any>({
        method: 'delete',
        url: `/seller/deleteDeptById`,
        params: { id: deptID }
    }),
    createDept: (data: any): Promise<any> => makeApiCall<any>({
        method: 'post',
        url: '/seller/createDept',
        data
    }),
    updateDeptById: (id: any, data: any): Promise<any> => makeApiCall<any>({
        method: 'put',
        url: `/seller/updateDeptById`,
        params: { id: id },
        data
    }),
    fetchDeptById: (id: any): Promise<any> => makeApiCall<any>({
        method: 'get',
        url: `/seller/fetchDeptById`,
        params: { deptId: id }
    }),
};

export default departments;
